
export class HistoryVariantAdd {
  public restrict: string;
  public templateUrl: string | ((tElement: JQuery, tAttrs: any) => string);
  public controller: any;
  public scope: any;
  public controllerAs: string;
  public bindToController: boolean;
  public template: string;
  public transclude: boolean | any;
  // tslint:disable-next-line:no-reserved-keywords
  public require: Array<string> | string;
  public link: ng.IDirectiveLinkFn | ng.IDirectivePrePost;
  public replace: boolean;

  constructor() {
    this.bindToController = true;
    this.controller = 'HistoryVariantAddController';
    this.controllerAs = 'vm';
    this.restrict = 'E';
    this.templateUrl = 'app/features/catalogues/catalogue/history/detail/detail_viewers/history_variant_add.html';
    this.scope = {
      variantDetail: '=',
      action: '='
    };
  }
}